// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__nGFje","HeroImg":"Hero_HeroImg__uyQdi","HeroBottom":"Hero_HeroBottom__0IiFF","HeroText":"Hero_HeroText__G4F6k"};